import { BadgeProps, ButtonProps } from '@commenda/kakashi';

export const ONBOARDING_STEP_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

export type OnboardingStepStatus =
  (typeof ONBOARDING_STEP_STATUS)[keyof typeof ONBOARDING_STEP_STATUS];

export interface OnboardingChecklistItem {
  icon: React.ReactElement;
  heading: string;
  description: string;
  button: {
    label: string;
    disabled: boolean;
    icon: React.ReactNode;
    onClick: () => void;
    variant?: ButtonProps['variant'];
    isLoading?: boolean;
  };
  status: OnboardingStepStatus;
  badge: {
    label: string;
    variant: BadgeProps['variant'];
  } | null;
}
